<footer class="footer mt-auto py-3 bg-primary">
    <div class="container-sm">
        <div class="row text-center b-0 m-0">
            <div class="col align-self-center b-0 m-0">
                <button type="button" class="btn shadow-none fs-5 text-white" (click)="contacts()">Contatti</button>
            </div>
            <div class="col align-self-center b-0 m-0">
                <button type="button" class="btn shadow-none fs-5 text-white" (click)="privacyPolicy()">Privacy policy</button>
            </div>
            <div class="col align-self-center b-0 m-0">
                <button type="button" class="btn shadow-none fs-5 text-white" (click)="termsOfService()">Termini di servizio</button>
            </div>
        </div>
    </div>
</footer>
<hr>